import ApiConnection from "./connection";

const download = async (token, month, year, reports) => {
  try {
    const response = await ApiConnection.post(
      `files/download/${month}/${year}`,
      reports, // Envia os reports no corpo da requisição
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob", // 🔥 ESSENCIAL
      },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const downloadRedeSus = async (token, dataInicio, dataFinal, reports) => {
  try {
    const response = await ApiConnection.post(
      `rede-sus/files/download/${dataInicio}/${dataFinal}`,
      reports, // Envia os reports no corpo da requisição
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob", // 🔥 ESSENCIAL
      },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

export default function file() {
  return {
    download,
    downloadRedeSus,
  };
}
